import { createContext, useContext, useMemo, useState } from "react";

const defaultRecaptcha = {
    recaptchaToken: null,
    onHandleRecaptchaToken: () => { }
}
export const RecaptchaContext = createContext(defaultRecaptcha)

export const RecaptchaProvider = ({ children }) => {
    const [recaptchaToken, setRecaptchaToken] = useState(null)

    const onHandleRecaptchaToken = (value) => setRecaptchaToken(value)

    const recaptchaProviderValue = useMemo(() => ({
        recaptchaToken,
        onHandleRecaptchaToken
    }), [recaptchaToken, onHandleRecaptchaToken])

    return (
        <RecaptchaContext.Provider value={recaptchaProviderValue}>
            {children}
        </RecaptchaContext.Provider>
    )
}

export const useRecaptcha = () => {
    const context = useContext(RecaptchaContext)

    if (!context) {
        throw new Error("useRecaptcha has to be used within <RecaptchaContext.Provider>");
    }

    return context;
}